import { createFromIconfontCN } from '@ant-design/icons';

export default createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_5036694_c4hpvdiw0nr.js',
});
